module.exports = __webpack_public_path__ + "welcome-user-bg.1d52ecc8f0369a9cd123.png";


//////////////////
// WEBPACK FOOTER
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/assets/img/welcome-user-bg.png
// module id = ../../../../../src/assets/img/welcome-user-bg.png
// module chunks = styles